module.exports = require('./helpers/bundle-url').getBundleURL('6D0M9') + "logo-dark.eefe0b7f.svg";